



































































import {Component, Mixins} from 'vue-property-decorator';
import ContentSection from '@/components/ContentSection.vue';
import {IContentSection} from '@/components/types';

import Benefits from '@/components/Benefits.vue';
import OpenAccount from '@/components/OpenAccount.vue';
import PricingPlans from '@/components/PricingPlans.vue';
import AnimatedCards from '@/components/AnimatedCards.vue';
import Icon from '@/components/ui/Icon.vue';
import CarouselWrapper from '@/components/homepage/Carousel.vue';

import ScrollTo from '@/mixins/ScrollTo';
import {Back, gsap} from '@/utils/gsap';


@Component({
	components: {
		'v-content-section': ContentSection,
		'v-benefits': Benefits,
		'v-open-account': OpenAccount,
		'v-pricing-plans': PricingPlans,
		'v-animated-cards': AnimatedCards,
		'v-carousel': CarouselWrapper
	}
})
export default class IndexPage extends Mixins(ScrollTo) {
	afterLoadTL: any = undefined;

	$refs!: {
		benefits: Benefits,
		// animation
		gold: Icon
		white: Icon
		green: Icon
		phone: HTMLElement
	};

	get visual(): any {
		return {
			default: process.env.ASSET_BASE + require(`@/images/homepage/visual/visual.jpg`),
			retina: process.env.ASSET_BASE + require(`@/images/homepage/visual/visual@2.jpg`)
		};
	}

	get carouselTop(): any {
		return this.$t('homepage.carouselTop');
	}

	get carouselBottom(): any {
		return this.$t('homepage.carouselBottom');
	}

	get content(): IContentSection {
		return {
			headline: this.$t('homepage.visual.headline') as string,
			perex: this.$t('homepage.visual.perex') as string,
			buttons: [
				{
					variant: 'primary',
					to: {
						query: {
							modal: this.appModalName
						}
					},
					label: this.$t('button.getApp') as string
				},
			],
			icon: 'symbols/letters/a-blue'
		};
	}

	get appModalName(): string {
		return this.$t('routes.getApp.modalName') as string;
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}

		this.afterLoadTL = gsap.timeline({paused: true});

		const gold = this.$refs.gold.$el;
		const white = this.$refs.white.$el;
		const green = this.$refs.green.$el;
		const phone = this.$refs.phone;

		this.afterLoadTL
			.set([white, green, phone], {opacity: 0})

			.set(gold, {scale: 1.2, rotateZ: -90, x: 0, y: -100})
			.set(white, {scale: 0.8, rotateZ: -111, x: -125, y: 10})
			.set(green, {scale: 0.8, rotateZ: -120, x: -185, y: 25})

			.fromTo(gold, 0.6, {
				scale: 1.2,
				rotationX: -20,
			}, {
				scale: 1,
				rotationX: 0,
				opacity: 1,
				ease: Back.easeOut.config(2)
			}, 0.2)
			.fromTo(gold, 0.6, {
				rotateZ: -90,
				x: 0,
				y: -100,
				scale: 1,
			}, {
				rotateZ: -110,
				x: -82,
				y: -20,
				scale: 0.75,
				ease: Back.easeOut.config(4)
			}, 1)
			.fromTo(white, 0.2, {opacity: 0}, {opacity: 1}, '-=0.2')
			.to(white, 0.6, {
				rotateZ: -121,
				x: -145,
				y: -10,
				scale: 0.75,
				ease: Back.easeOut.config(1)
			}, '-=0.2')
			.fromTo(green, 0.2, {opacity: 0}, {opacity: 1}, '-=0.4')
			.to(green, 0.6, {
				rotateZ: -130,
				x: -205,
				y: 5,
				scale: 0.75,
				ease: Back.easeOut.config(1)
			}, '-=0.2')
			.fromTo(phone, 0.4, {
				scaleY: 1.2,
				scaleX: 0.8,
				y: 200,
				opacity: 0,
			}, {
				scaleY: 1,
				scaleX: 1,
				y: 0,
				opacity: 1,
				ease: Back.easeOut.config(4)
			}, '-=0.4')
		;

		this.afterLoadTL.seek(0);

		this.$root.$on('isLoaded', (isLoaded: boolean) => {
			if (!isLoaded) {
				return;
			}

			this.afterLoadTL.play();
		});

		if (!this.$store.state.global.preloaded) {
			return;
		}

		this.afterLoadTL.progress(0.99);
	}
}
